import styles from './style.module.less';
import type { ReactElement } from 'react';

export function Require(props: { require?: boolean }): ReactElement {
  if (props?.require === true) {
    return <span className={styles.aster}>＊</span>;
  }
  return <></>;
}
